<template>
  <section class="recently_viewed" v-if="recentlyViewed.length">
    <div class="container-fluid px-0">
      <div class="recently-viewed my-5">
        <h5 class="mb-4 font-weight-bold">Recently Viewed</h5>
        <div class="row">
          <div
            class="col-md-6 col-lg-3 mb-4"
            v-for="(recentlyViewedProduct, index) in recentlyViewed"
            :key="index"
          >
            <div class="product-wrapper text-center">
              <div class="product-img px-4 py-3 position-relative">
                <AddToWishlist v-if="isLoggedIn" :prod="recentlyViewedProduct.product" />
                <ProductImage :product="recentlyViewedProduct.product" :zoom="false" imageSize="xl" />
              </div>
              <div class="px-3 pb-3">
                <div class="product-details">
                  <div class="product-name mb-1">
                    <ProductName :product="recentlyViewedProduct.product" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import AddToWishlist from './AddToWishlist.vue';
import ProductImage from './ProductImage.vue';
import ProductName from './ProductName.vue';
import { useGetters } from "@/composables";

const { isLoggedIn } = useGetters();

// Data
const recentlyViewed = ref([]);

// Methods
const fetchRecentlyViewed = () => {
  if (isLoggedIn.value) {
    axios
      .post(
        `${process.env.VUE_APP_API_BASE}auth/fetchRecentlyView`,
        {},
        {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        recentlyViewed.value = response.data.products;
      });
  } else {
    recentlyViewed.value = [];
  }
};

// Lifecycle
onMounted(() => {
  fetchRecentlyViewed();
});
</script>
<style>
.recently_viewed,
.recently_viewed .container {
  padding-left: 0px;
  padding-right: 0px;
}
</style>